import { createChipSuggestion } from "../rich-chip-editor/chip-suggestion";
import { isMatch } from "../../data-display/matched-text";
import { MentionList, type MentionListProps } from "./mention-list";
import type { Mentionable } from "./types";

/**
 * The `@` popup's matches for a typed query, capped at the popup's 10 rows.
 * Only the shown name is searched, so every listed row highlights its match.
 */
export function filterMentionables(items: Mentionable[], query: string): Mentionable[] {
  return items.filter((item) => !query || isMatch(item.name ?? item.username, query)).slice(0, 10);
}

/**
 * Builds the `@`-suggestion config for the mention surface on top of the shared
 * chip-suggestion machinery. `getItems` returns the latest mentionable set
 * (passed through a ref so the editor isn't rebuilt when it changes).
 */
export function createMentionSuggestion(getItems: () => Mentionable[]) {
  return createChipSuggestion<Mentionable, MentionListProps>({
    char: "@",
    allowSpaces: true,
    items: (query) => filterMentionables(getItems(), query),
    component: MentionList,
    componentProps: (props) => ({
      items: props.items,
      command: props.command,
      query: props.query,
    }),
  });
}
